import React, { useState ,useEffect } from 'react';
import axios from 'axios';
import Shineyeffect from './Shineyeffect'

const Reviews = () => {
  const [reviews ,setreviews] = useState([])
  const [startIndex, setStartIndex] = useState(0);
  useEffect(() => {
    const fetchData = async () => {
        try {
            const response = await axios.get('https://por2.onrender.com/api/reviews');
            setreviews(response.data.data); // Set projects directly from response.data.data
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    fetchData();
}, []); // Fetch data when the component mounts
  const handlePrevClick = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };
  const handleNextClick = () => {
    if (startIndex < reviews.length - 3) {
      setStartIndex(startIndex + 1);
    }
  };
  return (
    <div className="relative flex items-center justify-center ">
      <button 
        data-aos="fade-up"
        data-aos-delay='100'
        data-aos-duration='1400' 
        onClick={handlePrevClick} 
        className={`absolute  left-0 md:left-12 p-2 bg-sky-500 rounded-full `}>
        &lt;
      </button>
      <div 
        data-aos="fade-up"
        data-aos-delay='100'
        data-aos-duration='1400'  
      className="md:flex md:justify-start md:items-center md:overflow-hidden space-y-3 md:space-x-4 p-4">
        {reviews.slice(startIndex, startIndex + 3).map((review, index) => (
          <div key={index} className=" max-w-[270px]  md:min-w-[300px] md:max-w-[600px]  bg-white p-4 rounded-lg shadow-md">
            <h3 className="text-xl font-semibold">{review.attributes.name}</h3>
            <p className="mt-2 text-gray-600">{review.attributes.content}</p>
            <div className="mt-2">
              {"⭐".repeat(review.attributes.rating)}
            </div>
          </div>
        ))}
      </div>
      
      <button 
        data-aos="fade-up"
        data-aos-delay='100'
        data-aos-duration='1400' 
        onClick={handleNextClick} 
        className={`absolute right-0 md:right-12 p-2 bg-sky-500  rounded-full `}>
        &gt;
      </button>
    </div>
  );
};

export default Reviews;
